export default "__VITE_ASSET__nOARvkFb__"